import { DatiqPanelPopupSchema } from '@dat/datiq-components-pkg/panel-popup';
import { z } from 'zod';
import { DatiqCellLabelSchema } from '../../datiq-cell-label';

export const DatiqCellPopupSchema = z.object({
    id: z.string(),
    panel: DatiqPanelPopupSchema,
    label: DatiqCellLabelSchema,
    data: z.unknown().optional()
});

export interface IDatiqCellPopup extends z.infer<typeof DatiqCellPopupSchema> {}
